import React, { useEffect, useState } from "react";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import { ResultRoundPageIcon } from "~/assets/svg/PageIntroIcon";
import {
	ExcelIcon,
	PdfIcon,
	PrintIcon,
	SearchIcon,
	SortBottom,
	SortTop,
} from "~/assets/svg/InterfaceIcon";
import "~/assets/sass/pages/round/roundManage/result.scss";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import darkLogoImg from "~/assets/img/defaultImg/dark-vc-logo-rec.png";
import lightLogoImg from "~/assets/img/defaultImg/light-vc-logo-rec.png";
import darkProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useParams } from "react-router";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import moment from "moment";
import useDebounce from "~/common/hooks/useDebounce";
import useAlert from "~/common/hooks/useAlert";
import { useGlobalStore } from "~/store";

const RoundResult = () => {
	const [
		{
			sidebar: { currentPath },
			theme: { theme },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	const params = useParams();
	const roundResultRequest = useRequest("get", "/vc/round/review/result");
	const roundSendResultRequest = useRequest("post", `/vc/round/result/email/${params.idx}`);
	const [roundData, setRoundData] = useState({});
	const [judgeList, setJudgeList] = useState([]);
	const [applyCompanyList, setApplyCompanyList] = useState([]);
	const [targetdAverage, setTargetAverage] = useState(0);
	const [searchWord, setSearchWord] = useState("");
	const [judgeInfoList, setJudgeInfoList] = useState([]);
	const zero = 0;

	const [showInfoAlert, InfoAlert] = useAlert();
	const [showWarningAlert, WarningAlert] = useAlert();

	const openViewModal = (data) => {
		openDetailModal(data.stIdx);
	};

	const sendResult = () => {
		if (currentPath.auth !== "edit") {
			showAuthAlert();
			return;
		}
		if (roundData?.resultEmail) {
			showWarningAlert();
		} else {
			const resultList = [];
			applyCompanyList.forEach((company) => {
				const judgeForCompany = [];

				judgeList?.forEach((judge) => {
					const judgeResult = judge.Company.find((s) => s.stIdx === company.stIdx);
					judgeForCompany.push(judgeResult);
				});

				let sum = 0;
				let commentList = [];
				judgeForCompany.forEach((judge) => {
					if (judge) {
						sum += judge.score ?? 0;
						judge.comment && commentList.push(judge.comment);
					}
				});

				const dataObject = {
					startupIndex: company.stIdx,
					roundName: roundData.title,
					roundStartDate: moment(roundData.startDate).format("YYYY-MM-DD"),
					roundEndDate: moment(roundData.endDate).format("YYYY-MM-DD"),
					companyName: company.companyName,
					resultAvg: sum / judgeList?.length,
					judgeCommentList: commentList,
				};

				resultList.push(dataObject);
			});

			showInfoAlert().then(() => {
				roundSendResultRequest.singleCall(resultList, "body");
			});
		}
	};

	useEffect(() => {
		roundResultRequest.call(params.idx, "path");
	}, []);

	useEffect(() => {
		switch (roundResultRequest.state) {
			case API_STATE.done:
				const response = roundResultRequest.response.data;
				setRoundData(response.round);
				setJudgeList(response.round?.Judge);
				setApplyCompanyList(response.applyCompany);
				setJudgeInfoList(response.roundJudgeInfo);
				break;
			case API_STATE.error:
				console.log("roundListRequest error>> ", roundResultRequest.error);
				alert("잠시 후 다시 시도하여 주십시오.");
				break;
			default:
				break;
		}
	}, [roundResultRequest.state, roundResultRequest.response, roundResultRequest.error]);

	useEffect(() => {
		switch (roundSendResultRequest.state) {
			case API_STATE.done:
				roundResultRequest.call(params.idx, "path");
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [roundSendResultRequest.state]);

	const headerButtons = [
		<button type="button" className="btn-circle" disabled>
			<PrintIcon />
		</button>,
		<button type="button" className="btn-circle" disabled>
			<PdfIcon />
		</button>,
		<button type="button" className="btn-circle" disabled>
			<ExcelIcon />
		</button>,
		<button
			type="button"
			className={`btn__solid ${roundData?.resultEmail ? "disabled" : ""}`}
			color="primary"
			onClick={() => sendResult()}
		>
			결과통보
		</button>,
	];

	const [resultCommentModal, setResultCommentModal] = useState(false);
	const [targetIdx, setTargetIdx] = useState();

	const modalTargetJudge = judgeList
		?.map((ty) => {
			return ty.Company?.map((t) => {
				if (t.stIdx === targetIdx) {
					return {
						...t,
						name: ty.name,
						img:
							judgeInfoList?.find((judgeInfo) => judgeInfo.idx === ty.userIdx)?.img ||
							(theme === "dark" ? darkProfileImg : lightProfileImg),
					};
				} else {
					return undefined;
				}
			}).find((d) => d);
		})
		.filter((d) => d);

	const openDetailModal = (stIdx) => {
		setTargetIdx(stIdx);
		setResultCommentModal(true);
	};

	const onChangeSearchWord = useDebounce((e) => {
		setSearchWord(e.target.value);
	}, 300);

	return (
		<>
			<NavbarAndSidebarLayout
				menu={["round", "management"]}
				type={"main"}
				menuName={"round-result"}
			>
				<PageHeader buttonList={headerButtons} />
				<div className="pageIntro">
					<ResultRoundPageIcon />
					<div className="content">
						<h3>{roundData.title}</h3>
						<p>
							{moment(roundData.startDate).format("YYYY-MM-DD")} ~
							{moment(roundData.endDate).format("YYYY-MM-DD")}
						</p>
					</div>
				</div>
				<div className="c__card result-round-card">
					<div className="list-top">
						<div className="switch-wrap">
							{/*<label className="switch">*/}
							{/*	<input type="checkbox" />*/}
							{/*	<span className="slider round" />*/}
							{/*	<span className="slider-label">최대·최소 배제</span>*/}
							{/*</label>*/}
						</div>
						<div className="c__search">
							<input
								className="c__input"
								placeholder="기업명을 입력해 주세요"
								onChange={onChangeSearchWord}
							/>
							<button type="button" className="btn-search">
								<SearchIcon />
							</button>
						</div>
					</div>
					<div className="scroll-wrap">
						<div className="c__table">
							<div className="thead">
								<div className="tr">
									<div className="th number">No</div>
									<div className="th company">기업명</div>
									<div className="th ceo">대표</div>
									<div className="th judging-vc">
										<div className="label">심사역</div>
										<div className="vc-group">
											{judgeList?.map((d, idx) => (
												<div key={idx}>{d.name}</div>
											))}
										</div>
									</div>
									<div className="th percent">심사율</div>
									<div className="th total">합계</div>
									<div className="th average">
										평균
										<button className="btn-sort ascend">
											<SortTop />
											<SortBottom />
										</button>
										{/*<button className="btn-sort descend">*/}
										{/*	<SortTop/>*/}
										{/*	<SortBottom/>*/}
										{/*</button>*/}
									</div>
									<div className="th commentary">심사평</div>
								</div>
							</div>
							<div className="tbody">
								{applyCompanyList
									?.filter((company) => company.companyName.includes(searchWord))
									.map((applyCompany, idx_1) => {
										const judgedCompany = judgeList?.map((judge) =>
											judge.Company?.find(
												(review) => review.stIdx === applyCompany.stIdx
											)
										);

										const numOfJudge = judgedCompany.length;
										const numOfDoneJudge = judgedCompany.filter(
											(d) => d
										).length;
										const donePercentage = (numOfDoneJudge / numOfJudge) * 100;

										let sum = 0;
										judgedCompany?.forEach((d) => {
											sum += d?.score || 0;
										});

										const average = sum / numOfDoneJudge;

										return (
											<div className="tr" key={idx_1}>
												<div className="td number">{idx_1 + 1}</div>
												<div className="td company">
													{applyCompany.companyName}
												</div>
												<div className="td ceo">
													{applyCompany.ceoName || "-"}
												</div>
												<div className="td judging-vc">
													<div className="vc-group">
														{judgeList?.map((d, idx_2) => {
															const judgeScore = d.Company.find(
																(s) =>
																	s.stIdx === applyCompany.stIdx
															);
															return (
																<div key={idx_2}>
																	{judgeScore?.score === 0
																		? zero.toFixed(2)
																		: judgeScore?.score || "-"}
																</div>
															);
														})}
														{/* {judgedCompany?.map((d, idx) => {

													return (
														<div key={idx}>{d?.score || "-"}</div>
													)
												})} */}
													</div>
												</div>
												<div className="td percent">
													{donePercentage.toFixed(2)}%
												</div>
												<div className="td total">{sum.toFixed(2)}</div>
												<div className="td average">
													{isNaN(average)
														? zero.toFixed(2)
														: average.toFixed(2)}
												</div>
												<div className="td commentary">
													{numOfDoneJudge > 0 ? (
														<button
															type="button"
															className="btn__outline"
															color="primary"
															onClick={() => {
																openViewModal(applyCompany);
																setTargetAverage(average);
															}}
														>
															보기
														</button>
													) : (
														"-"
													)}

													{/* <button
													type="button"
													className="btn__outline"
													color="primary"
													onClick={() => setResultCommentModal(true)}
												>
													보기
												</button> */}
												</div>
											</div>
										);
									})}
							</div>
						</div>
					</div>
				</div>

				{/*심사평 모달*/}
				<ModalTemplate
					modalState={resultCommentModal}
					setModalToggle={setResultCommentModal}
					title="심사평"
					width={600}
					className="result-commentary-modal"
				>
					<div className="modal-content">
						<div className="result-commentary-header">
							<div className="header-company-info">
								<div className="img-wrap">
									<img
										src={
											applyCompanyList?.find(
												(company) => company.stIdx === targetIdx
											)?.logoSqu ||
											(theme === "dark" ? darkLogoImg : lightLogoImg)
										}
										alt="로고이미지"
									/>
									{/*<img src={lightLogoImg} alt="로고이미지" />*/}
								</div>
								<div className="header-company-admin">
									<p className="company">
										{
											applyCompanyList?.find(
												(company) => company.stIdx === targetIdx
											)?.companyName
										}
									</p>
									<p className="ceo">
										{applyCompanyList?.find(
											(company) => company.stIdx === targetIdx
										)?.ceoName || "-"}
									</p>
								</div>
							</div>
							<div className="header-company-total">
								<span className="company-total-label">최종 평점</span>
								<span className="company-total-score">
									<b>
										{isNaN(targetdAverage)
											? zero.toFixed(2)
											: targetdAverage.toFixed(2)}
									</b>
									점
								</span>
							</div>
						</div>
						<div className="scroll-wrap">
							<ul className="result-commentary-content">
								{modalTargetJudge?.map((d, idx) => (
									<li className="commentary-content" key={idx}>
										<div className="commentary-top">
											<div className="company-judge">
												<div className="img-wrap">
													<img src={d.img} alt="멤버샘플" />
												</div>
												<div className="judge-info">
													<p className="judge-name">{d.name}</p>
													<p className="judge-company">sd</p>
												</div>
											</div>
											<div className="judge-score">
												<p>
													<b>{d.score.toFixed(2)}</b>점
												</p>
											</div>
										</div>
										<div className="commentary-bottom">{d.comment}</div>
									</li>
								))}
							</ul>
						</div>
					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn__solid"
							color="primary"
							onClick={() => setResultCommentModal(false)}
						>
							확인
						</button>
					</div>
				</ModalTemplate>
			</NavbarAndSidebarLayout>
			<InfoAlert
				type="info"
				message="결과를 통보하시겠습니까?"
				subMessage="결과는 기업 관리자들에게 이메일로 전송됩니다"
				reject="아니요"
				confirm="예"
			/>
			<WarningAlert type="warning" message="결과는 한번만 통보 가능합니다" confirm="예" />
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</>
	);
};

export default RoundResult;
